import { downloadAllQueryGroupsCSV } from "@/helpers/apis";
import { DownloadTable } from "@/components/downloadTable";
import { useGroupsFilters } from "./useGroupsFilters";

interface GroupsDownloadProps {
  disabled?: boolean;
}

const GroupsDownload = ({ disabled }: GroupsDownloadProps) => {
  const { filterParams } = useGroupsFilters({});

  const handleDownload = async () => {
    await downloadAllQueryGroupsCSV(filterParams);
  };

  return (
    <DownloadTable handleDownload={handleDownload} buttonProps={{ disabled, variant: "outline" }} />
  );
};

export default GroupsDownload;
